<template>
  <div class="identite">

    <div class="titre">
      <span>{{$_('customer_account')}}</span>
    </div>

    <div v-if="Object.keys(getCustomer).length !== 0">
      <span class="sLibelle info">{{ getCustomer.TLIBCLI }}</span>
      <span class="info">
        Code :
        <span class="sCode">{{ getCustomer.TNCLI }}</span>
      </span>
      <span class="info">
        <span class="sVille">{{ getCustomer.TVILLE }}</span> (
        <span class="sPays">{{ getCustomer.TLPAYS }}</span>)
      </span>
    </div>

    <div class="bloc-bouton" v-if="getRole === 'A' || getRole === 'I' || getRole === 'R'">
      <button class="btn light identity" @click="open = true">{{ getCustomer.TNCLI ? $_('customer_change') : $_('customer_selection') }}</button>
      <button class="btn light identity" @click="vUnselectCustomer" v-if="getCustomer.TNCLI">{{$_('detach')}}</button>
    </div>

    <CustomModal 
      :title="$_('customer_select')"
      :open="open"
      @close-modal="open = false">
      <template slot="modal_content">
        <CustomerList @load-customer="vLoadCustomer($event)"></CustomerList>
      </template>
    </CustomModal>
    
  </div>
</template>

<script>
import CustomerList from "@/modules/client/components/CustomerList";
import CustomModal from "@/common/components/widget/Modal/CustomModal";

import customerService from '@/modules/client/services/customerService';

export default {
  components: {
    CustomModal,
    CustomerList,
  },
  data() {
    return {
      open: false
    };
  },
  created() {

    let user = this.$store.getters['application/get_application_company'].PTUSER;


    if(user === 'C') {

      customerService.getCustomer({
        poffset: 0,
        plimit: 9999
      })
      .then(res => {
        this.$store.dispatch('application/SATABAPP_STORE', {key: 'satabapp-customer', val: res.data.DS_O.OUT[0]})
        this.$store.dispatch('application/SATABAPP_LOAD');
      });
    }
  },
  computed: {
    getCustomer() {
      return this.$store.getters['application/get_application_customer'];
    },
    getRole() {
      return this.$store.getters['application/get_application_company'].PTUSER;
    }
  },
  methods: {
    vLoadCustomer(event) {
      this.$store.dispatch('application/SATABAPP_STORE', {key: 'satabapp-customer', val: event.customer})
      this.$store.dispatch('application/SATABAPP_LOAD');
      this.open = false;
    },
    vUnselectCustomer() {
      this.$store.dispatch('application/SATABAPP_STORE', {key: 'satabapp-customer', val: '' })
      this.$store.dispatch('application/SATABAPP_LOAD');
      window.location.reload(true);
    }
  }
};
</script>

<style scoped>
.titre {
  text-align: center;
  font-size: 18px;
  padding-bottom: 5px;
  border-bottom: solid #e9e9e9 1px;
  margin-bottom: 10px;
  position: relative;
}
.identite {
  border: solid #e9e9e9 1px;
  border-radius: 5px;
  padding: 10px;
  color: #8b8b8b;
  margin: 10px;
  font-size: 14px;
}
span.info {
  display: block;
  padding: 3px;
}
.bloc-bouton {
  text-align: center;
  padding: 10px;
}
.btn.identity {
  padding: 13px 8px;
  width: 100%;
  margin-top: 10px;
  font-family: "Lato-Regular";
}
</style>